const heightOffset = 100;
export default heightOffset;